<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <div class="flex map flex column align-center" [ngClass]="{'content-full-screen': contentFillTheScreen}">
    <ng-container *ngIf="googleMapLoaded">
      <google-map *ngIf="latitude && longitude" [center]="{lat: +latitude, lng: +longitude }" [zoom]="zoom">
        <app-map-clusterer
          [isLayerColor]="true"
          [color]="'success'"
          icon="bold-driver"
          iconClass="text-success"
          [type]="IconType.SVG"
          [size]="'md'"
          *ngIf="filteredDrivers?.length"
          [circleColor]="'bg-success-lighter'"
        >
          <app-map-overlay
            [latitude]="+driver.latitude"
            [markerDraggable]="false"
            [longitude]="+driver.longitude"
            *ngFor="let driver of filteredDrivers"
          >
            <div class="overlay">
              <div class="layer-one" [class.unavailable]="driver.shipmentId">
                <div class="layer-two layer-marker-size" [class.unavailable]="driver.shipmentId">
                  <app-marker [color]="driver.shipmentId?'error':'success'" [size]="'md'">
                    <div
                      class="circle-layer flex align-center justify-center"
                      [ngClass]="{
                    'bg-error-lighter': driver.shipmentId,
                    'bg-success-lighter':!driver.shipmentId
                  }"
                    >
                      <app-icon
                        name="bold-driver"
                        [ngClass]="{
                        'text-error': driver.shipmentId,
                        'text-success':!driver.shipmentId
                      }"
                        (click)="onSelectDriver(driver)"
                        size="xs"
                      ></app-icon>
                    </div>
                  </app-marker>
                </div>

                <div *ngIf="driver.selected" class="data flex column" [ngClass]="{'fade-in': showFadeIn}">
                  <div class="flex status align-center justify-space-between">
                    <p *ngIf="+selectedDriver.shipmentId" class="unavailable small radius-1 weight-medium mb-0">
                      {{'LiveTracking.Enum.DriverTrackingStatus.Unavailable' | translate}}
                    </p>
                    <p *ngIf="!+selectedDriver.shipmentId" class="available small radius-1 weight-medium mb-0">
                      {{'LiveTracking.Enum.DriverTrackingStatus.Available' | translate}}
                    </p>
                    <img src="../../../../../assets/images/close.svg" class="close-icon" (click)="driver.selected = !driver.selected" />
                  </div>
                  <!-- 
                  <div class="flex column shipment" *ngIf="selectedDriver.shipmentId">
                    <div class="flex title">
                      <p class="small">{{'LiveTracking.ShipmentInformation' | translate}}</p>
                    </div>
                  </div> -->
                  <h6 *ngIf="truck?.productType?.name" class="small weight-medium text-800">{{truck.type?.name}}</h6>

                  <mat-divider *ngIf="selectedDriver.truck?.id" class="my-2"></mat-divider>
                  <app-row align="center" *ngIf="selectedDriver.truck?.id ">
                    <h6 *ngIf="selectedDriver?.productType?.name" class="small weight-medium text-800">{{selectedDriver.type?.name}}</h6>

                    <app-col cols="6 " *ngIf="selectedDriver.truck?.plateNumber " class="mb-2">
                      <span class="text-400 small weight-normal">{{'LiveTracking.PlateNumber' | translate}}</span>
                      <p class="font-size-xs weight-normal text-800">{{selectedDriver.truck?.plateNumber}}</p>
                    </app-col>
                    <app-col cols="6 " *ngIf="selectedDriver.truck?.brand" class="mb-2">
                      <span class="text-400 small weight-normal">{{'LiveTracking.TruckBrand' | translate}}</span>
                      <p class="font-size-xs weight-normal text-800">{{selectedDriver.truck?.brand.name }}</p>
                    </app-col>
                    <app-col cols="6 " *ngIf="selectedDriver.truck?.type">
                      <span class="text-400 small weight-normal">{{'Providers.VehicleType' | translate}}</span>
                      <p class="font-size-xs weight-normal text-800">{{selectedDriver.truck?.type?.name}}</p>
                    </app-col>
                    <app-col cols="6 " *ngIf="selectedDriver.nationality">
                      <span class="text-400 small weight-normal">{{'LiveTracking.Country' | translate}}</span>
                      <p class="font-size-xs weight-normal text-800">{{selectedDriver.nationality}}</p>
                    </app-col>

                    <div class="flex select" *ngIf="showSelectButton ">
                      <button (click)="selectDriver() ">{{'LiveTracking.Buttons.Select' | translate}}</button>
                    </div>
                  </app-row>
                  <mat-divider class="my-2" *ngIf="selectedDriver.driverId"></mat-divider>
                  <app-row align="center">
                    <div class="flex align-center">
                      <div class="mr-4">
                        <app-avatar
                          *ngIf="selectedDriver.driverId"
                          bgColor="transparent"
                          src="/assets/images/driver-image-placeholder.svg"
                          [round]="true"
                        ></app-avatar>
                      </div>

                      <div>
                        <p *ngIf="selectedDriver.user?.name" class="text-600 weight-semibold m-0 mb-1 card__content-subtxt">
                          {{selectedDriver.user?.name}}
                        </p>
                        <div *ngIf="selectedDriver.iqamaId" class="small weight-normal">
                          <span>{{'LiveTracking.Driver.IqamaId' | translate}}: {{selectedDriver.iqamaId}}</span>
                        </div>

                        <!-- <div cols="12" class="flex align-center" *ngIf="selectedDriver.driverId">
                          <span class="small weight-normal">{{'LiveTracking.DriverId' | translate}}:&nbsp;</span>
                          <span class="small weight-normal">
                            <a
                              class="text"
                              [routerLink]="routesUtil.FleetsDriversView.url({ id: selectedDriver.driverId })"
                              target="_blank"
                              class="small"
                            >
                              {{selectedDriver.driverId}}
                            </a>
                          </span>
                        </div> -->
                        <div *ngIf="selectedDriver?.user?.mobileNumber" class="small weight-normal mb-1">
                          <span>{{'LiveTracking.Driver.PhoneNo' | translate}}. {{selectedDriver?.user?.mobileNumber }}</span>
                        </div>
                        <div class="flex" *ngIf="selectedDriver.date">
                          <span class="small weight-normal">
                            {{'LiveTracking.LocationDate' | translate}}:&nbsp; {{ selectedDriver.date | date: 'MMM d, y, h:mm:ss a' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </app-row>
                  <mat-divider class="my-2"></mat-divider>

                  <div>
                    <p *ngIf="selectedDriver?.driverId|| selectedDriver.shipmentId" class="small weight-semibold mb-2">
                      {{'LiveTracking.VisitProfiles' | translate}}
                    </p>
                    <div class="flex align-center wrap">
                      <div *ngIf="selectedDriver.shipmentId ">
                        <button class="btn-enhanced radius-1 border-1 flex align-center small py-2 px-4 text-primary mr-1">
                          <app-icon name="box" class="mr-2" size="xs"></app-icon>
                          <a
                            class="text-primary-light"
                            [routerLink]="routesUtil.ShipmentsViewWithoutRange.url({ id: selectedDriver.shipmentId, type: ShipmentsListType.All }) "
                            target="_blank"
                          >
                            {{'LiveTracking.Shipment' | translate}}
                          </a>
                        </button>
                      </div>
                      <div *ngIf="selectedDriver.driverId ">
                        <button class="btn-enhanced radius-1 border-1 flex align-center small py-2 px-4 text-primary mr-1">
                          <app-icon name="driver" class="mr-2 text-primary" size="xs"></app-icon>

                          <a
                            class="text-primary-light"
                            target="_blank"
                            [routerLink]="routesUtil.FleetsDriversView.url({ id: selectedDriver.driverId  }) "
                          >
                            {{'LiveTracking.Driver' | translate}}
                          </a>
                        </button>
                      </div>
                      <!-- <div *ngIf="selectedDriver.truck?.id">
                  <button class="btn-enhanced radius-1 border-1 flex align-center small py-2 px-4 text-primary small">
                    <app-icon name="truck " class="mr-2" size="sm "></app-icon>

                    <a class="text-primary" [routerLink]="RoutesUtil.FleetsTrucksView.url({ id:selectedDriver.truck?.id}) " target="_blank ">
                      {{'LiveTracking.Truck' | translate}}
                    </a>
                  </button>
                </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-map-overlay>
        </app-map-clusterer>
      </google-map>
    </ng-container>

    <!-- <agm-map
        [latitude]="latitude "
        [longitude]="longitude "
        [zoom]="zoom "
        [streetViewControl]="false "
        [zoomControl]="false "
      >
        <agm-marker [latitude]="latitude " [longitude]="longitude " [markerDraggable]="true "></agm-marker>
      </agm-map> -->
  </div>
</app-state-section>
